import React from 'react'
import styled from 'styled-components'
// import { withRouter } from 'react-router-dom'
import { Col, Layout, Menu, Row, Dropdown, Badge } from 'antd'
import { BellOutlined, DownOutlined, NotificationOutlined, ShoppingCartOutlined } from '@ant-design/icons'
import { logoutAction } from 'Store/user/actions'
import { connect, useDispatch } from 'react-redux'
import { MyTheme } from 'Components/common/Theme'
import RootState from 'typings/RootState'
import { selectCurrentUser } from 'Store/user/selector'
import { MerchantAvatar } from 'Components/avatar'
import { selectNewOrder } from 'Store/orders/selector'
import { Link, useNavigate } from 'react-router-dom'
import { getUserLogin } from 'helpers/account'
import LogoImage from 'Components/logo/LogoImage'

const { Header } = Layout

type Props = ReduxProps & {}

const NavBar: React.FunctionComponent<Props> = props => {
  const { user, newOrder } = props
  const userInfo = getUserLogin()
  const isStaff = userInfo && userInfo?.store_type === 'merchant_staff'
  const count = newOrder?.total || 0
  const history = useNavigate()

  const dispatch = useDispatch()

  const onLogout = (): void => {
    dispatch(logoutAction())
  }

  const onChangeMerchant = (): void => {
    history('/mymerchants')
  }

  const onGotoManageUser = (): void => {
    history('/manage-user')
  }

  const menu = (
    <MyMenu>
      <Menu.Item onClick={onChangeMerchant}>เลือกร้านค้า</Menu.Item>
      {!isStaff && <Menu.Item onClick={onGotoManageUser}>ตั้งค่าผู้ใช้งาน</Menu.Item>}
      <Menu.Item>
        <Link to={'/merchant-profile'}>ข้อมูลร้านค้า</Link>
      </Menu.Item>
      <Menu.Item onClick={onLogout}>ออกจากระบบ</Menu.Item>
    </MyMenu>
  )

  return (
    <HeaderArea className="header">
      <Row justify="end" align="middle" gutter={[8, 8]}>
        <Col>
          <Dropdown overlay={menu} trigger={['click']}>
            <MenuDropdown onClick={e => e.preventDefault()}>
              <Row align="middle">
                <Col>
                  <MerchantAvatar logo={user?.activeMerchant?.logo || ''} />
                </Col>
                <Col>
                  <MerchantName>{user?.activeMerchant?.name || 'ไม่มีร้านค้า'}</MerchantName>
                </Col>
                <Col>
                  <DownOutlined />
                </Col>
              </Row>
            </MenuDropdown>
          </Dropdown>
        </Col>
      </Row>
    </HeaderArea>
  )
}

const HeaderArea = styled(Header)`
  height: 50px;
  line-height: 50px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  margin-bottom: 2px;
  padding: 0 0 0 30px;
  .ant-menu-horizontal {
    border: none;
    background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  }
  .ant-menu-item {
    margin: 0;
  }
  @media only screen and (max-width: 720px) {
    padding: 0 10px;
  }
`

const MenuDropdown = styled.div`
  padding: 0 20px;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.drakGrey};
  cursor: pointer;
  border-left: 1px solid #ffffff6b;
`

const MyMenu = styled(Menu)`
  .ant-dropdown-menu-item,
  .ant-dropdown-menu-submenu-title {
    padding: 12px;
  }
`

const MerchantName = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 5px;
  white-space: nowrap;
  @media only screen and (max-width: 720px) {
    max-width: 180px;
  }
`

const mapStateToProps = (state: RootState): any => {
  return {
    user: selectCurrentUser(state),
    newOrder: selectNewOrder(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(mapStateToProps)(NavBar)
